import { configureStore } from '@reduxjs/toolkit';
import homeReducer from './feature/feature';

const store = configureStore({
  reducer: {
    feature: homeReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
